<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="headline">
					<span>Detail Outstanding</span>
					<span class="pl-2 font-weight-bold">{{ detailOutstanding.po_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Detail Warehouse</div>
							<div class="pt-1">{{detailOutstanding.warehouse_name}}</div>
							<div class="pt-1">{{detailOutstanding.warehouse_email}}</div>
							<div class="pt-1">{{detailOutstanding.warehouse_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailOutstanding)}}</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Outstanding</div>
							<v-col cols="8" class="mt-1 pa-0">
								<div class="cyan darken-2 rounded text-body-2 text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 justify-center">
									<div>{{detailOutstanding.po_status | toStatusPOWH}}</div>
								</div>
							</v-col>
						</v-col>
					</v-row>
					<v-list color="grey lighten-3" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card outlined class="mb-5">
						<v-data-table dense :headers="headers" :items="detailOutstanding.detail" hide-default-footer>
							<template v-slot:item.draft="{ item }">
								<div>
									{{ item.po_detail_outstanding.draft | toNumber }}
								</div>
							</template>
							<template v-slot:item.on_delivery="{ item }">
								<div>{{ item.po_detail_outstanding.on_delivery | toNumber }}</div>
							</template>
							<template v-slot:item.outstanding="{ item }">
								<div>{{ item.po_detail_outstanding.outstanding | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'po_detail_supplier_product_name', sortable: false },
			{ text: 'Outstanding', value: 'outstanding', align: 'center', sortable: false },
			{ text: 'Sedang Dikirim', value: 'on_delivery', align: 'center', sortable: false },
			{ text: 'Belum Dikirim', value: 'draft', align: 'center', sortable: false },
			],
		}
	},
	computed:{
		...mapState('poOutstanding', ['detailOutstanding']),
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.warehouse_address)
				data.push(value.warehouse_address)
			if (value.warehouse_subdistrict_name)
				data.push(value.warehouse_subdistrict_name)
			if (value.warehouse_city_name)
				data.push(value.warehouse_city_name)
			if (value.warehouse_province_name)
				data.push(value.warehouse_province_name)
			return data.join(', ')
		}
	}
};
</script>